export const UPDATE_HEALTH_CHECKLIST = 'UPDATE_HEALTH_CHECKLIST'
export const updateHealthCheckList = (healthCheckList) => ({
  type: UPDATE_HEALTH_CHECKLIST,
  payload: healthCheckList,
})

export const UPDATE_FINANCIAL_CHECKLIST = 'UPDATE_FINANCIAL_CHECKLIST'
export const updateFinancialCheckList = (financialCheckList) => ({
  type: UPDATE_FINANCIAL_CHECKLIST,
  payload: financialCheckList,
})
